import Loadable from 'react-loadable';
import CircleLoader from 'ggApp/shared/components/CircleLoader';

const Step = Loadable({
    loader: () => import(/* webpackChunkName: "SwapStep" */ './Step.tsx'),
    timeout: 500,
    loading: CircleLoader,
});
export default Step;
